import { render, staticRenderFns } from "./AiDraftPage.vue?vue&type=template&id=9fd92f22&"
import script from "./AiDraftPage.vue?vue&type=script&lang=js&"
export * from "./AiDraftPage.vue?vue&type=script&lang=js&"
import style0 from "./AiDraftPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports